import React, { Component } from "react";
import { render } from "react-dom";
import { object, string } from "prop-types";
import _ from 'lodash'

// utils
import { createQuery, runQuery } from "../../../utils/KeenReport";
import { formatPercentage } from "../../../utils/numeral";
import { post } from "../../../utils/apiService";

// components
import Spinner from "../../Spinner";

// c3
import C3Chart from "react-c3js";
import "c3/c3.css";

// arrow
import arrowRight from "../../../_assets/images/arrow_right_2.png";
import conversionBadge from "../../../_assets/images/conversion_badge.png";

class RegularFunnelWithClicksInBars extends Component {
  constructor(props) {
    super(props);

    let uniqueId;
    if (this.props.video) {
      uniqueId =
        "regularfunnelwithclicksinbars" +
        this.props.video.id +
        this.props.actor;
    } else {
      uniqueId =
        "regularfunnelwithclicksinbars" +
        this.props.campaign.id +
        this.props.actor;
    }

    this.state = {
      isLoading: true,
      hasError: false,
      uniqueId: uniqueId
    };

    this.runKeen = this.runKeen.bind(this);
    this.changeState = this.changeState.bind(this);
    this.createQueries = this.createQueries.bind(this);
    this.configureChartWithSendings = this.configureChartWithSendings.bind(
      this
    );
    this.buildQueriesForPeople = this.buildQueriesForPeople.bind(this);
    this.buildQueriesForEvents = this.buildQueriesForEvents.bind(this);
    this.calculateRatios = this.calculateRatios.bind(this);
    this.getSendingsSize = this.getSendingsSize.bind(this);
  }
  componentDidMount() {
    this.runKeen(this.props);
  }
  componentWillReceiveProps(nextProps) {
    if (!_.isEqual(nextProps.timeframe, this.props.timeframe)) {
      this.changeState("loading");
      this.runKeen(nextProps);
    }
    if (!_.isEqual(nextProps.filters, this.props.filters)) {
      this.changeState("loading");
      this.runKeen(nextProps);
    }
    if (!_.isEqual(nextProps.labelFilter, this.props.labelFilter)) {
      this.runKeen(nextProps);
    }
  }
  changeState(type) {
    let isLoading, hasError;
    switch (type) {
      case "loading":
        isLoading = true;
        hasError = false;
        break;
      case "error":
        isLoading = false;
        hasError = true;
        break;
      case "done":
        isLoading = false;
        hasError = false;
        break;
      default:
        isLoading = false;
        hasError = false;
        break;
    }

    this.setState({
      isLoading,
      hasError
    });
  }
  buildQueriesForPeople(props) {
    const {
      campaign,
      timeframe,
      video,
      filters,
      labelFilter,
      typeFilter
    } = props;
    let queries = [];
    let extraFilters;
    if (labelFilter !== "") {
      extraFilters = [
        ...filters,
        {
          operator: "eq",
          property_name: typeFilter,
          property_value: labelFilter
        }
      ];
    } else {
      extraFilters = filters;
    }
    // Cliques
    queries.push(
      createQuery(
        "count_unique",
        "url_expanded",
        timeframe,
        null,
        video,
        "viewer_id",
        null,
        extraFilters
      )
    );
    // Visitas
    queries.push(
      createQuery(
        "count_unique",
        "video_recomended",
        timeframe,
        campaign,
        video,
        "client_viewer_id",
        null,
        extraFilters
      )
    );
    // Plays
    queries.push(
      createQuery(
        "count_unique",
        "video_unique_click",
        timeframe,
        campaign,
        video,
        "client_viewer_id",
        null,
        extraFilters
      )
    );
    // Understanding
    queries.push(
      createQuery(
        "count",
        "user_interacted",
        timeframe,
        campaign,
        video,
        "client_viewer_id",
        null,
        [
          ...extraFilters,
          {
            operator: "eq",
            property_name: "source",
            property_value: "entendeu-diferenca"
          },
          { operator: "eq", property_name: "value", property_value: "sim" }
        ]
      )
    );
    // Conversoes
    queries.push(
      createQuery(
        "count",
        "ux",
        timeframe,
        campaign,
        video,
        "client_viewer_id",
        null,
        [
          ...extraFilters,
          {
            operator: "eq",
            property_name: "source",
            property_value: "baixar-app"
          }
        ]
      )
    );
    return queries;
  }
  buildQueriesForEvents(props) {
    const {
      campaign,
      timeframe,
      video,
      filters,
      labelFilter,
      typeFilter
    } = props;
    let queries = [];
    let extraFilters;
    if (labelFilter !== "") {
      extraFilters = [
        ...filters,
        {
          operator: "eq",
          property_name: typeFilter,
          property_value: labelFilter
        }
      ];
    } else {
      extraFilters = filters;
    }
    // Cliques
    queries.push(
      createQuery(
        "count",
        "url_expanded",
        timeframe,
        null,
        video,
        null,
        null,
        extraFilters
      )
    );
    // Visitas
    queries.push(
      createQuery(
        "count",
        "video_recomended",
        timeframe,
        campaign,
        video,
        null,
        null,
        extraFilters
      )
    );
    // Plays
    queries.push(
      createQuery(
        "count",
        "video_unique_click",
        timeframe,
        campaign,
        video,
        null,
        null,
        extraFilters
      )
    );
    // Understanding
    queries.push(
      createQuery(
        "count",
        "user_interacted",
        timeframe,
        campaign,
        video,
        null,
        null,
        [
          ...extraFilters,
          {
            operator: "eq",
            property_name: "source",
            property_value: "entendeu-diferenca"
          },
          { operator: "eq", property_name: "value", property_value: "sim" }
        ]
      )
    );
    // Conversoes
    queries.push(
      createQuery("count", "ux", timeframe, campaign, video, null, null, [
        ...extraFilters,
        {
          operator: "eq",
          property_name: "source",
          property_value: "baixar-app"
        }
      ])
    );
    return queries;
  }
  createQueries(props) {
    const { actor } = props;
    let queries;
    if (actor === "pessoas") {
      queries = this.buildQueriesForPeople(props);
    } else {
      queries = this.buildQueriesForEvents(props);
    }
    return queries;
  }
  configureChartWithSendings(config) {
    const actor = config.props.actor;
    let label = actor[0].toUpperCase() + actor.substring(1);
    const data = {
      columns: [
        [
          label,
          config.totalSendings,
          config.clicks,
          config.visits,
          config.plays,
          config.understandings,
          config.conversions
        ],
        ["Target", null, 70, 110, 60, 10, 10]
        // ["Target", null, 904, 723, 651, 586, 521]
      ],
      type: "bar",
      types: {
        Target: "line"
      },
      labels: true
    };
    const axis = {
      x: {
        type: "category",
        categories: [
          "Envios",
          "Cliques",
          "Visitas",
          "Plays",
          "Entendimentos",
          "Conversões"
        ]
      }
    };
    const bar = {
      width: {
        ratio: 0.3 // this makes bar width 50% of length between ticks
      }
    };
    let chartConfig = {
      data,
      axis,
      bar
    };
    const mountNode = document.getElementById(this.state.uniqueId);
    const chart = (
      <C3Chart
        data={chartConfig.data}
        axis={chartConfig.axis}
        bar={chartConfig.bar}
      />
    );
    render(chart, mountNode);
  }
  calculateRatios(results) {
    let visitRate = results.visits / results.clicks;
    let playRate = results.plays / results.visits;
    let understandingRate = results.understandings / results.plays;
    let conversionRate = results.conversions / results.understandings;

    let totalConversionRate = results.conversions / results.clicks;

    this.setState({
      visitRate,
      playRate,
      conversionRate,
      understandingRate,
      totalConversionRate
    });
  }
  getSendingsSize(props) {
    return new Promise((resolve, reject) => {
      const { video, filters } = props;
      let filterRequest;
      if (filters.length > 0) {
        filterRequest = filters[0]["property_value"];
      } else {
        filterRequest = [];
      }
      let url = `/campaigns/${video.campaign_id}/videos/${
        video.id
      }/sending_tag_size`;
      let data = {
        sending_tags: filterRequest
      };
      post(url, data)
        .then(res => {
          let totalSendings = res.data.total_campaign_sendings_size;
          resolve(totalSendings);
        })
        .catch(err => {
          this.changeState("error");
          console.log("Error!!");
        });
    });
  }
  runKeen(props) {
    let queries = this.createQueries(props);
    runQuery(queries)
      .then(res => {
        let clicks = res[0].result;
        let visits = res[1].result;
        let plays = res[2].result;
        let understandings = res[3].result;
        let conversions = res[4].result;

        let results = {
          props,
          clicks,
          visits,
          plays,
          understandings,
          conversions
        };

        this.getSendingsSize(props).then(totalSendings => {
          results["totalSendings"] = totalSendings;
          props.loadTotal(results);
          this.calculateRatios(results);
          this.configureChartWithSendings(results);
          this.changeState("done");
        });
      })
      .catch(err => {
        console.log("Erro rodando a query do Keen.", err);
        this.changeState("error");
      });
  }
  render() {
    let { isLoading, hasError, uniqueId } = this.state;
    const { labelFilter } = this.props;
    return (
      <div>
        <div
          style={containerStyle}
          className={isLoading || hasError ? "hidden" : ""}
        >
          {labelFilter !== "" ? <h2>Filtro: {labelFilter}</h2> : false}
          <div style={{ width: "90%" }} id={uniqueId} />
          <div style={arrowVisitRateStyle}>
            {formatPercentage(this.state.visitRate, "0[.]0%")}
          </div>
          <div style={arrowPlayRateStyle}>
            {formatPercentage(this.state.playRate, "0[.]0%")}
          </div>
          <div style={arrowUnderstandingRateStyle}>
            {formatPercentage(this.state.understandingRate, "0[.]0%")}
          </div>
          <div style={arrowConversionRateStyle}>
            {formatPercentage(this.state.conversionRate, "0[.]0%")}
          </div>
          <div style={conversionBadgeStyle}>
            {formatPercentage(this.state.totalConversionRate, "0[.]0%")}
            <span style={conversionBadgeStyleSpan}>Taxa de conversão</span>
          </div>
        </div>
        <Spinner
          isLoading={isLoading}
          hasError={hasError}
          runKeen={() => {
            this.runKeen(this.props);
          }}
        />
      </div>
    );
  }
}

const containerStyle = {
  position: "relative"
};

const arrowStyle = {
  background: `url(${arrowRight})`,
  backgroundRepeat: "no-repeat",
  backgroundSize: "contain",
  width: "7%",
  height: "22%",
  color: "#666",
  fontWeight: "bold",
  fontSize: "14px",
  position: "absolute",
  paddingTop: "1.2%"
};

const arrowVisitRateStyle = {
  ...arrowStyle,
  top: "43%",
  left: "29%"
};

const arrowPlayRateStyle = {
  ...arrowStyle,
  top: "43%",
  left: "44%"
};

const arrowUnderstandingRateStyle = {
  ...arrowStyle,
  top: "44%",
  left: "58%"
};

const arrowConversionRateStyle = {
  ...arrowStyle,
  top: "44%",
  left: "72%"
};

const conversionBadgeStyle = {
  background: `url(${conversionBadge})`,
  backgroundRepeat: "no-repeat",
  backgroundSize: "contain",
  height: 120,
  position: "absolute",
  top: "30%",
  right: "3%",
  color: "black",
  textAlign: "center",
  lineHeight: "86px",
  fontWeight: "bold",
  width: "12%"
};

const conversionBadgeStyleSpan = {
  lineHeight: 1.2,
  width: "100%",
  position: "absolute",
  top: "100%",
  left: 0
};

RegularFunnelWithClicksInBars.propTypes = {
  timeframe: object,
  campaign: object,
  actor: string,
  video: object
};

export default RegularFunnelWithClicksInBars;



// WEBPACK FOOTER //
// ./src/components/charts/Funnels/RegularFunnelWithClicksInBars.js